define("shared/components/shared/button/media-uploader", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/object/internals", "@ember/service", "@glimmer/component", "ember-concurrency", "ember-concurrency-ts"], function (_exports, _component, _templateFactory, _object, _internals, _service, _component2, _emberConcurrency, _emberConcurrencyTs) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/internals",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"ember-concurrency-ts"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div ...attributes>
    <Shared::Ui::Button
      @additional={{@additional}}
      @class={{@buttonClass}}
      @isDisabled={{not this.canUpload}}
      @onClick={{this.handleClick}}
      @size={{@size}}
      @text={{@text}}
      @variant={{@variant}}
    />
    <Input
      @type="file"
      accept={{@accept}}
      class="u--hide"
      id={{this.inputId}}
      multiple={{gt @uploadLimit 1}}
      {{on "change" (perform this.handleFileChange)}}
    />
  </div>
  */
  {
    "id": "kNZRuIEW",
    "block": "[[[11,0],[17,1],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@additional\",\"@class\",\"@isDisabled\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[30,2],[30,3],[28,[37,1],[[30,0,[\"canUpload\"]]],null],[30,0,[\"handleClick\"]],[30,4],[30,5],[30,6]]],null],[1,\"\\n  \"],[8,[39,2],[[16,\"accept\",[30,7]],[24,0,\"u--hide\"],[16,1,[30,0,[\"inputId\"]]],[16,\"multiple\",[28,[37,3],[[30,8],1],null]],[4,[38,4],[\"change\",[28,[37,5],[[30,0,[\"handleFileChange\"]]],null]],null]],[[\"@type\"],[\"file\"]],null],[1,\"\\n\"],[13]],[\"&attrs\",\"@additional\",\"@buttonClass\",\"@size\",\"@text\",\"@variant\",\"@accept\",\"@uploadLimit\"],false,[\"shared/ui/button\",\"not\",\"input\",\"gt\",\"on\",\"perform\"]]",
    "moduleName": "shared/components/shared/button/media-uploader.hbs",
    "isStrictMode": false
  });

  /**
   * This component is used to render a button that can be used to upload media files.
   * It uses the genericMediaManager service to upload file via S3.
   *
   * Arguments:
   * - [size] (String) Button Size, Options: "small", "regular", "large" (default: "regular")
   * - [variant] (String) Button color styling, Options: "primary", "default", "proceed", "outline", "danger", "mute", "unstyled" (default: "primary")
   * - [additional] (String) Button options, Available options: "rounded", "circle", "block" (default: null)
   * - [text] (String) The text displayed on the button.Required for inline usage. If this component is invoked as a block,
   *   the block contents will be used instead of this property. (default: "")
   * - [accept] (String) The file types that can be uploaded. (Example: ".jpeg, .jpg, .png")
   * - [attachmentType] (String) The type of attachment to be uploaded for model creation.
   * - [uploadLimit] (Number) The maximum number of files that can be uploaded. The uploader is disabled if this is 0.
   * - [onAttachmentUpload] (Function) A callback function that is called when an attachment finishes uploading.
   * - [onLengthError] (Function) Function to call if over upload limit, can be used to display limit information to user.
   *
   */
  let MediaUploaderComponent = (_dec = (0, _emberConcurrency.task)({
    enqueue: true,
    maxConcurrency: 1
  }), (_class = class MediaUploaderComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "errors", _descriptor, this);

      _initializerDefineProperty(this, "genericMediaManager", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _defineProperty(this, "inputId", `media-input-${(0, _internals.guidFor)(this)}`);
    }

    get isUploading() {
      return (0, _emberConcurrencyTs.taskFor)(this.uploadFile).isRunning;
    }

    get canUpload() {
      return this.args.uploadLimit > 0 && !this.isUploading;
    }

    handleClick(event) {
      event.preventDefault();
      document.getElementById(this.inputId)?.click();
    }

    *handleFileChange(_ref) {
      let {
        target: {
          files
        }
      } = _ref;

      if (files.length > this.args.uploadLimit && this.args.onLengthError) {
        this.args.onLengthError();
      }

      yield (0, _emberConcurrency.allSettled)(Array.from(files).slice(0, Math.min(files.length, this.args.uploadLimit)).map(file => (0, _emberConcurrencyTs.taskFor)(this.uploadFile).perform(file)));
    }

    *uploadFile(file) {
      try {
        const attachment = yield this.genericMediaManager.uploadImage.perform(file, {
          attachmentType: this.args.attachmentType,
          setPreview: url => attachment.previewUrl = url
        });
        this.args.onAttachmentUpload(attachment);
      } catch (error) {
        this.errors.show(`${this.intl.t('influencers.campaigns.details.upload_inspiration_error')} ${file.name}`, error);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "genericMediaManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleFileChange", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "handleFileChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "uploadFile", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "uploadFile"), _class.prototype)), _class));
  _exports.default = MediaUploaderComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MediaUploaderComponent);
});